import { useState, useEffect, useCallback, useMemo } from "react";
import ApiService from "../../../../services/api";


import { useLocation } from "react-router-dom";
function useResultData(apiUrl) {
  const location = useLocation();
  const id = location?.state?.id; 
  const [result, setResult] = useState(null);
  const [testSolutions, setTestSolutions] = useState(null);
  const [testSubjects,setTestSubjects]=useState([]);
  const [trackerId,setTrackerId]=useState(null);
  const [testSubjectsTopic,setSubjectsTopic]=useState([]);

  const fetchData = useCallback(async () => {
    try {
      console.log(location,"here",id);
      const res = await ApiService.getTestReport(id);
      if (res && res?.data) {
        setResult(res?.data?.data);
        const subjects=res?.data?.data?.sectionalMarkings?.map((value)=>{
          return value?.section;

        })
        setTestSubjects(subjects);
       
      }
    } catch (err) {
      console.log(err);
      // fireToast("error", err.response.data.message, undefined, true);
    }
  }, [id]);

  useEffect(()=>{
    const fetchExamSolutions=async ()=>{
      try {
        const res = await ApiService.getTestSolutions(id);
        if (res && res?.data?.data) {
          console.log(res?.data?.data,"t67");
          setTestSolutions(res?.data?.data);
  
        }
      } catch (err) {
        console.log(err);
        // fireToast("error", err.response.data.message, undefined, true);
      }
    }
    fetchExamSolutions();

  },[id])

  

  const memoizedFetchData = useMemo(() => fetchData, [fetchData]);

  useEffect(() => {
    memoizedFetchData();
  }, [memoizedFetchData]);
 
  

  useEffect(() => {
    ApiService.getTestTracker(id)
      .then((res) => {
        if (!!res) {
          let data = res?.data?.data;
          setTrackerId(data?.trackerId);
        }
      })
      .catch((err) => {
        console.log(err);
        // fireToast("error", err.response.data.message, undefined, true);
      });
  }, [id]);
  useEffect(()=>{



    const fetchSubjectWiseTestReport=async (subject) => {
    try {
       const lang="en";
      
       const res = await ApiService.getSubjectWiseReport(trackerId,subject,lang);
       if (res && res?.data) {
        
        setSubjectsTopic((prevData) => ({
          ...prevData,
          [subject]: res?.data?.data,
        }));
      }
    } catch (err) {
      console.log(err);
      // fireToast("error", err.response.data.message, undefined, true);
    }
    
  }
  if(trackerId && testSubjects){

    testSubjects.forEach((subject) => {
      fetchSubjectWiseTestReport(subject);
    });
  }

}, [trackerId,testSubjects]);
  
console.log(testSolutions,"t56");
  return { result ,testSolutions,testSubjectsTopic,trackerId};
}

export default useResultData;
